import { Text } from 'blaze-ui/Text/Text'
import Styles from './EmptyState.module.scss'

export const EmptyState = () => {
  return (
    <div className={Styles.emptyState}>
      <img
        src="https://res.cloudinary.com/almanac/image/upload/v1727086641/blaze_assets/hd_icons/search_dk25eh.png"
        alt=""
      />
      <Text variant="primary" color="var(--dark-60)">
        Hmm... We didn’t find anything.
        <br />
        Try another search.
      </Text>
    </div>
  )
}
